import axios from 'axios';
import { config } from '../assets/config/config';

const apiUrl = config.api.url;

const getDatafastVisitorId = () => {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith('datafast_visitor_id='));
  return match ? match.split('=')[1] : null;
};

const initiatePayment = (amount, currency = 'USD', referralCode = null) => {
  const payload = {
    amount: amount, 
    currency: currency, 
  }
  if (referralCode) {
    payload.referralCode = referralCode;
  }
  return axios.post(`${apiUrl}/v1/paypal/initiate-payment`, payload);
};

const capturePayment = (orderId, credits, amountBeforeReferral, referralInfo = null) => {
  const payload = {
    orderId: orderId,
    credits: credits,
    amountBeforeReferral: amountBeforeReferral,
  };
  if (referralInfo) {
    payload.referralInfo = referralInfo;
  }
  const visitorId = getDatafastVisitorId();
  if (visitorId) {
    payload.datafastVisitorId = visitorId;
  }
  return axios.post(`${apiUrl}/v1/paypal/capture-payment`, payload);
};

const createSubscription = (subscriptionId) => {
  const payload = { subscriptionId };
  const visitorId = getDatafastVisitorId();
  if (visitorId) {
    payload.datafastVisitorId = visitorId;
  }
  return axios.post(`${apiUrl}/v1/paypal/create-subscription`, payload);
};

const deleteSubscription = (subscriptionId, reason = null, comments = null) => {
  const payload = { subscriptionId };
  if (reason !== null) payload.reason = reason;
  if (comments !== null) payload.comments = comments;
  return axios.post(`${apiUrl}/v1/paypal/delete-subscription`, payload);
};

export const paypalService = {
  initiatePayment,
  capturePayment,
  createSubscription,
  deleteSubscription,
};
